import type { PLACubeViewSettings } from "./PLACubeTimeView";

const settingsKey = (projectId: string) => `PLAState-globalCubeView-${projectId}`;

export function readPLACubeViewSettings(storage: Pick<Storage, "getItem">, projectId: string): PLACubeViewSettings {
   const saved = storage.getItem(settingsKey(projectId));
   if (!saved) return { dimensionId: storage.getItem(`PLAState-timeDimension-${projectId}`) || "" };
   try {
      const value: unknown = JSON.parse(saved);
      if (!value || typeof value !== "object") throw new Error("Expected cube view settings object");
      return {
         dimensionId: "dimensionId" in value && typeof value.dimensionId === "string" ? value.dimensionId : "",
         memberId: "memberId" in value && typeof value.memberId === "string" ? value.memberId : undefined,
         latest: "latest" in value && value.latest === true
      };
   } catch (error) {
      console.warn("Failed to restore PLA global cube settings", error);
      return { dimensionId: storage.getItem(`PLAState-timeDimension-${projectId}`) || "" };
   }
}

export function savePLACubeViewSettings(storage: Pick<Storage, "setItem">, projectId: string, settings: PLACubeViewSettings): void {
   storage.setItem(settingsKey(projectId), JSON.stringify({
      dimensionId: settings.dimensionId || "",
      memberId: settings.memberId,
      latest: Boolean(settings.latest)
   }));
}
